import { render, staticRenderFns } from "./PropostaFormulario.vue?vue&type=template&id=0fcbc0fc&"
import script from "./PropostaFormulario.vue?vue&type=script&lang=js&"
export * from "./PropostaFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports